import { API } from "./axiosInstance"

/**
 * Gets all the contactReasonMembers from the usermanagement-service
 * @param {*} staticMemberId The id of the member
 * @returns the contactReasonsMembers
 */
export const getContactReasonMembersforMember = async (staticMemberId, optionalParameterString = "") => {
    const contactReasonsMember = await API.get(`/contactReasonsMembers?memberId=${staticMemberId + optionalParameterString}`);
    return contactReasonsMember.data;
}

/**
 * Calls the post contactReasonsMembers endpoint
 * @param {*} contactReasonsMember the contactReasonsMember to create
 * @returns the response from usermanagement-service
 */
export const createContactReasonMember = async (contactReasonsMember) => {
    const response = await API.post(`/contactReasonsMembers`, contactReasonsMember);
    return response.data;
}

/**
 * Calls the put contactReasonsMembers endpoint
 * @param {*} contactReasonsMember the contactReasonsMember to update
 * @returns the response from usermanagement-service
 */
export const updateContactReasonMember = async (contactReasonsMember, staticId) => {
    const response = await API.put(`/contactReasonsMembers/${staticId}`, contactReasonsMember);
    return response.data;
}

/**
 * Accepts a requested change for a contactReasonsMember
 * @param {*} staticId the id of the contactReasonsMember in the static model
 * @returns the accepted contactReasonsMember
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/contactReasonsMembers/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a contactReasonsMember
 * @param {*} staticId the id of the contactReasonsMember in the static model
 * @returns the rejected contactReasonsMember
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/contactReasonsMembers/${staticId}/reject`);
    return response.data;
}